import request from '@/utils/request'

export function getTodolist(query) {
    console.log("get_todolist",typeof(query))
    // console.log("get_question", query)
    if(typeof(query)=="number"){
        return request({
            url: '/api/schedule/' + query,
            method: 'get',
        })
    }
    else{
        return request({
            url: '/api/schedule/' + query,
            method: 'get',
        })
    }
}
export function insert_update_todolist(data) {
  // console.log(data);
    return request({
        url: '/api/schedule',
        method: 'post',
        data
    })
}